import { useNavigate } from "react-router-dom";
import { FaCalendarWeek, FaEye } from "react-icons/fa";
import { useEffect, useState } from "react";
import { useDisclosure } from "@chakra-ui/react";
import BookingDataService from "../../services/Booking";
import ExpertWeeklyCalendarModal from "../Modals/ExpertWeeklyCalendarModal";
import { DateTime } from "luxon";

export const SingleTimingRow = ({ props, id }: any) => {
  const { full_name, timing, leaves } = props;
  const [modal, setModal] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();

  const token = localStorage.getItem("logged_in_user_token");

  const calculateTotalTimingHours = (
    timing: Record<string, { start: string; end: string }[]>
  ) => {
    if (!timing) {
      return 0;
    }
    let totalMinutes = 0;

    Object.values(timing).forEach((daySlots) => {
      daySlots.forEach(({ start, end }) => {
        const [startH, startM] = start.split(":").map(Number);
        const [endH, endM] = end.split(":").map(Number);

        const startTotal = startH * 60 + startM;
        const endTotal = endH * 60 + endM;

        if (endTotal > startTotal) {
          totalMinutes += endTotal - startTotal;
        }
      });
    });

    return totalMinutes / 60;
  };

  const totalTimingHours = calculateTotalTimingHours(timing);

  const getTimings = (day: any) => {
    if (!timing) return "No Timings";

    const objectLength = Object.keys(timing).length;

    if (objectLength > 0) {
      const data = timing[day];

      if (data && data.length > 0) {
        return (
          <div>
            {data.map((el: any, index: number) => (
              <div key={index}>
                <strong>{`${el.start}-${el.end}`}</strong>
              </div>
            ))}
          </div>
        );
      } else {
        return <div>No Timings</div>;
      }
    }

    return <div>No Timings</div>;
  };

  const navigate = useNavigate();

  const [currentWeekBookings, setCurrentWeekBookings] = useState<any>([]);
  const [nextWeekBookings, setNextWeekBookings] = useState<any>([]);
  const [currentWeekBookingsHours, setCurrentWeekBookingsHours] =
    useState<any>();
  const [nextWeekBookingsHours, setNextWeekBookingsHours] = useState<any>();

  // const data = [
  //   {
  //     session_date_time: "2025-04-21T10:00:00.000",
  //     booking_status: "BOOKED",
  //     session_duration: 30,
  //   },
  //   {
  //     session_date_time: "2025-04-25T12:00:00.000",
  //     booking_status: "BOOKED",
  //     session_duration: 45,
  //   },
  //   {
  //     session_date_time: "2025-04-28T14:00:00.000",
  //     booking_status: "BOOKED",
  //     session_duration: 45,
  //   },
  //   {
  //     session_date_time: "2025-05-03T16:00:00.000",
  //     booking_status: "BOOKED",
  //     session_duration: 45,
  //   },
  // ];

  const getBookings = async () => {
    const startOfWeek = DateTime.local().startOf("week"); // Monday
    const currentWeekDates = [];

    for (let i = 0; i < 7; i++) {
      const date = startOfWeek.plus({ days: i });
      currentWeekDates.push(date.toFormat("MM/dd/yyyy"));
    }

    const startOfNextWeek = DateTime.local().plus({ weeks: 1 }).startOf("week");
    const nextWeekDates = [];

    for (let i = 0; i < 7; i++) {
      const date = startOfNextWeek.plus({ days: i });
      nextWeekDates.push(date.toFormat("MM/dd/yyyy"));
    }

    const currentSessions: any = await BookingDataService.expertWeeklyBookings(
      id,
      currentWeekDates
    );

    const nextSessions: any = await BookingDataService.expertWeeklyBookings(
      id,
      nextWeekDates
    );

    const formattedCurrentSessions = currentSessions.data.map((item: any) => {
      const sessionDateTime = DateTime.fromISO(item.session_date_time);
      const sessionDuration = item.session_duration;

      const start = sessionDateTime.hour + sessionDateTime.minute / 60;
      const duration = sessionDuration / 60; // in hours
      const end = start + duration;

      const dayOfWeek = sessionDateTime.toFormat("cccc");

      return {
        session_date: sessionDateTime.toISODate(), //(YYYY-MM-DD)
        start: parseFloat(start.toFixed(2)), // 24-hour float format
        end: parseFloat(end.toFixed(2)), // 24-hour float format
        duration,
        day: dayOfWeek,
      };
    });

    const formattedNextSessions = nextSessions.data.map((item: any) => {
      const sessionDateTime = DateTime.fromISO(item.session_date_time);
      const sessionDuration = item.session_duration;

      const start = sessionDateTime.hour + sessionDateTime.minute / 60;
      const duration = sessionDuration / 60; // in hours
      const end = start + duration;

      const dayOfWeek = sessionDateTime.toFormat("cccc");

      return {
        session_date: sessionDateTime.toISODate(),
        start: parseFloat(start.toFixed(2)),
        end: parseFloat(end.toFixed(2)),
        duration,
        day: dayOfWeek,
      };
    });

    setCurrentWeekBookingsHours(
      formattedCurrentSessions.reduce(
        (sum: any, item: any) => sum + item.duration,
        0
      )
    );
    setNextWeekBookingsHours(
      formattedNextSessions.reduce(
        (sum: any, item: any) => sum + item.duration,
        0
      )
    );

    setCurrentWeekBookings(formattedCurrentSessions);
    setNextWeekBookings(formattedNextSessions);
  };

  useEffect(() => {
    getBookings();
  }, []);

  return (
    <tr>
      <td className="flex items-center">
        <div className="flex-col items-start text-left">
          <div>{full_name}</div>
          <div>
            <strong>Current Week: </strong>
            {`${currentWeekBookingsHours} / ${totalTimingHours} Hrs`}
          </div>
          <div>
            <strong>Next Week: </strong>
            {`${nextWeekBookingsHours} / ${totalTimingHours} Hrs`}
          </div>
        </div>
        <span>
          <FaCalendarWeek
            color="#fdb508"
            onClick={() => {
              setModal("weeklyCalendar");
              onOpen();
            }}
          />
        </span>
      </td>
      <td>{getTimings("mon")}</td>
      <td>{getTimings("tue")}</td>
      <td>{getTimings("wed")}</td>
      <td>{getTimings("thu")}</td>
      <td>{getTimings("fri")}</td>
      <td>{getTimings("sat")}</td>
      <td>{getTimings("sun")}</td>
      <td>
        <div className="d-flex align-items-center">
          <button
            type="button"
            className="btn disabledButton"
            onClick={() => navigate(`/experts/view/${id}`)}
          >
            <FaEye style={{ color: "#f48a0f" }} />
          </button>
        </div>
      </td>
      {modal === "weeklyCalendar" && (
        <ExpertWeeklyCalendarModal
          isOpen={isOpen}
          onClose={onClose}
          timing={timing}
          currentBookings={currentWeekBookings}
          nextBookings={nextWeekBookings}
        />
      )}
    </tr>
  );
};
